import { paths } from 'src/routes/paths';

export const { VITE_APP_API_URL: APP_API_URL } = import.meta.env;
export const { VITE_CLIENT_HOST: CLIENT_HOST } = import.meta.env;

export const PATH_AFTER_LOGIN = paths.root;
export const PATH_AFTER_LOGOUT = paths.auth.login;
